var cifFi = ["301 185", "<g fill='none'><path fill='#FFF' d='M.5.833h300v183.333H.5z'/><path fill='#003580' d='M.5 67.5h300v50H.5z'/><path fill='#003580' d='M83.834.833h50v183.333h-50z'/></g>"];

export { cifFi };

